import { ChangeDetectionStrategy, Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { Subscription } from 'rxjs';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { LayoutService } from '../../../services/layout.service';
import { Router } from '@angular/router';
import { map, startWith } from 'rxjs';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {

    dataPadOpenSplit = [66, 33]
    minDatapadSizes = [50, 1]
    dataPadHeight = computed(() => this.layoutService.maxViewportHeightStyle())

    splitterPanelSizes = signal<number[]>([99, 1])

    currentUser = toSignal(this.authService.currentUser$)
    currentUrl = toSignal(
        this.router.events.pipe(
            startWith(null),
            map(() => this.router.url),
        ),
        { initialValue: this.router.url },
    )

    showNavigation = computed(() => {
        const user= this.currentUser()
        const url = this.currentUrl()

        // Photobooth is a kiosk-like experience; hide the MC nav bar there.
        if (url.includes('photobooth')) return false

        if (user && user.profileType === "staff" && user.roles.includes("fullsite")) {
            return true
        }
        else {
            return false
        }
    })

    private panelSizeListener: (event: CustomEvent) => void;

    constructor(
        private breakpointService: BreakpointService,
        private dataPadService: DataPadService,
        private authService: LocalAuthService,
        private layoutService: LayoutService,
        private router: Router,
    ) {
        // Create the event listener for custom datapad splitter resizing
        this.panelSizeListener = (event: CustomEvent) => {
            if (event.detail?.splitterSizes && event.detail?.panelName) {
                // You can add specific logic for different panel types here
                // For now, we'll apply the splitter sizes for any panel
                this.splitterPanelSizes.set(event.detail.splitterSizes);
            }
        };
    }

    private subscriptions: Subscription[] = []

    dataPadCountChange(count: number) {
        if (count === 0) {
            this.splitterPanelSizes.set([99, 1])
            this.dataPadService.globalDataPadActive$.next(false)
        }
        else {
            this.splitterPanelSizes.set(this.dataPadOpenSplit)
            this.dataPadService.globalDataPadActive$.next(true)
        }
    }

    ngOnInit(): void {
        this.subscriptions.push(this.breakpointService.dataPadFullScreen.subscribe(state => {
            if (state.matches) {
                this.dataPadOpenSplit = [1, 99]
                this.minDatapadSizes = [1, 1]
               
                 this.layoutService.updateMaxViewportHeightStyle('calc(100dvh - 69px)')
            }
            else {
                this.dataPadOpenSplit = [66, 33]
                this.minDatapadSizes = [50, 1]
                
                 this.layoutService.updateMaxViewportHeightStyle('calc(100dvh - 100px)')
            }
        }))
        
        // Add event listener for custom datapad splitter resizing
        window.addEventListener('dataPadSplitterResize', this.panelSizeListener as EventListener);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
        
        // Remove event listener when component is destroyed
        window.removeEventListener('dataPadSplitterResize', this.panelSizeListener as EventListener);
    }

}
